import { render, staticRenderFns } from "./MetaTags.vue?vue&type=template&id=3690d10e&"
import script from "./MetaTags.vue?vue&type=script&lang=js&"
export * from "./MetaTags.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports